import { queryOptions, useQuery } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

export interface OrganizationOption {
  id: string;
  name: string;
}

export function organizationOptionsQueryOptions() {
  return queryOptions({
    queryKey: organizationKeys.options(),
    queryFn: async (): Promise<OrganizationOption[]> => {
      const { items } = await organizationsApi.listAll();
      return items
        .map(({ id, name }) => ({ id, name }))
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    staleTime: 5 * 60_000,
  });
}

/** Every organization's id and name, for filters and for naming rows that only carry an id. */
export function useOrganizationOptions() {
  return useQuery(organizationOptionsQueryOptions());
}
